import {
  invoicingGetData,
  invoicingInputData,
  getWarningData
} from '@/api/api'

const state = {
  invoicingList: [],
  invoicingTotal: 0,
  warningData: []
}

const getters = {
  invoicingList: state => state.invoicingList,
  invoicingTotal: state => state.invoicingTotal,
  warningData: state => state.warningData
}

const actions = {
  loadInvoicingList ({ dispatch }, parm) {
    return invoicingGetData(parm).then((data) => {
      data.forEach((item) => {
        item.outVolume = parseInt(item.outVolume)
        item['oilTypeJ'] = item.oilType ? (item.oilType.split('号')[0] + '#') : ''
        item.collectTimeS = item.collectTime
        item.collectTime = item.collectTime ? item.collectTime.slice(5, 16) : '--'
      })
      dispatch('setInvoicingList', data)
    })
  },
  getWarningData ({ dispatch }, parm) {
    return getWarningData(parm).then((data) => {
      dispatch('setWarningData', data)
    })
  },
  setWarningData ({ commit }, data) {
    commit('setWarningData', data)
  },
  inputInvoicingData ({ dispatch }, parm) {
    return invoicingInputData(parm)
  },
  setInvoicingList ({ commit }, data) {
    commit('setInvoicingList', data)
  },
  setInvoicingTotal ({ commit }, data) {
    commit('setInvoicingTotal', data)
  }
}

const mutations = {
  setInvoicingList (state, data) {
    state.invoicingList = data
  },
  setWarningData (state, data) {
    state.warningData = data
  },
  setInvoicingTotal (state, data) {
    state.invoicingTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/invoicing.js